// extracted by mini-css-extract-plugin
export default {"wrapper":"crypto-table_wrapper__BjMsP","content":"crypto-table_content__8Vf-u","headerItem":"crypto-table_headerItem__eJ04d"};